export default __webpack_public_path__ + "static/media/cyber.098e3bfe.svg";